// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"fe31d14c47f0c10d46eb","303":"31ffc5c8472dd4714fd4","495":"3eab350989866783dda6"}[chunkId] + ".js";
};